// require("turbolinks").start();
import 'regenerator-runtime';
import Vue from 'vue';

type Options = {
  [key: string]: any;
};

function parseVueOptions(vueOptions: string) {
  if (!vueOptions) return {};
  try {
    return JSON.parse(vueOptions);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return {};
  }
}

export function initWithOptions(options: Options) {
  const vms = [];

  // TODO use turbolinks
  // document.addEventListener('turbolinks:load', function() {
  document.addEventListener('DOMContentLoaded', function() {
    const templates = document.querySelectorAll('[data-vue]');

    // FIXME NodeList は常に forEach が呼び出せるはずだが、時々 HTMLDocument になりエラーになっている。
    // 原因わからないので NodeList かどうかチェックを入れる
    // n.forEach is not a function
    // https://sentry.io/organizations/proff/issues/1566543309/?project=4311338&referrer=slack
    // https://developer.mozilla.org/en-US/docs/Web/API/NodeList
    if (!(templates instanceof NodeList)) return;

    templates.forEach((el: HTMLElement) => {
      const opt = options[el.dataset.vue];
      // skip no option in scope
      if (!opt) return;

      const vm = new Vue(
        Object.assign(opt, {
          el,
          propsData: { options: parseVueOptions(el.dataset.vueOptions) },
        })
      );
      vms.push(vm);
    });
  });

  // TODO use turbolinks
  // document.addEventListener('turbolinks:visit', function() {
  //  for (let vm of vms) {
  //    vm.$destroy();
  //  }
  //  vms = [];
  // });
}

export function initVueTurbolinksWithContext(requiredOptions) {
  const options = {};

  requiredOptions.keys().forEach(function(key) {
    const name = key
      .split('/')
      .pop()
      .split('.')
      .shift();
    options[name] = requiredOptions(key).default;
  });
  initWithOptions(options);
}
